module.exports = __webpack_public_path__ + "img/icon-1.b80a1429.png";